module.exports = __webpack_public_path__ + "img/Weapon_196.a0eb5b01.png";